import { deleteListQuery, searchListQuery, searchListsQuery, UnsubscribeListQuery } from '../constants';
import { NOT_SCHEDULED, handleSubscription } from './subscriptionsHelper';
import axios from 'axios';
const RESOURCE_TYPE_BIZREVIEW = 3;
const RESOURCE_TYPE_SCORECARD = 4;

export const deleteListById = async (listId, setDeleted) => {
  const postBody = {
    query: deleteListQuery,
    variables: {
      listId: Number(listId),
    },
  };

  try {
    const response = await axios.post(`${wbConfig.baseUrl}/vnext/searchApi/graphql`, postBody);
    if (response.data?.errors || !response.data?.data?.deleteList?.success) {
      console.error(response.data.errors || 'Failed to delete list');
      return;
    }
    setDeleted(listId);
  } catch (error) {
    console.error(error);
  }
};

export const unsubscribeFromListById = async (listId, setUnsubscribed) => {
  const postBody = {
    query: UnsubscribeListQuery,
    variables: {
      listId: Number(listId),
      userEmail: window.uData.email
    },
  };
  try {
    const response = await axios.post(`${wbConfig.baseUrl}/vnext/searchApi/graphql`, postBody);
    if (response.data?.errors || !response.data?.data?.unsubscribeFromList?.success) {
      console.error(response.data.errors || 'Failed to unsubscribe from list');
      return;
    }
    setUnsubscribed(listId);
  } catch (error) {
    console.error(error);
  }
};

export const getLists = async (limit, setData, setLoading) => {
  const postBody = {
    query: searchListsQuery,
    variables: {
      page: 0,
      limit,
      resourceType: 'all',
      filter: {
        operator: 'and',
        fields: {
          typeId: {
            in: [1, 2, 3, 4, 5],
          },
        },
      }
    },
  };

  try {
    const response = await axios.post(`${wbConfig.baseUrl}/vnext/searchApi/graphql`, postBody);
    if (response.data?.errors) {
      console.error(response.data.errors);
      return;
    }

    const lists = response.data?.data?.lists?.items.map((item) => ({
      id: item.id,
      name: item.name,
      owner: item?.owner?.id === window.uData.user_id ? 'You' : `${item?.owner?.firstname} ${item?.owner?.lastname}`,
      typeId: item?.type?.id,
      typeName: item?.type?.name,
      listOwner: item?.owner?.id,
      modified: new Date(Number(item?.updatedAt)).toLocaleDateString(undefined, {
        day: '2-digit',
        year: 'numeric',
        month: 'short',
      }),
      subscriptions: handleSubscription(item?.subscriptions),
      actions: {
        id: item.id,
        name: item.name,
      },
      type: item.type,
      isDynamic: item.isDynamic,
      contents: item.contents ?? [],
    })).filter((item) => !((item.typeId == RESOURCE_TYPE_BIZREVIEW || item.typeId == RESOURCE_TYPE_SCORECARD) && ((item.owner == 'You' && (item.contents.length === 0 || item.contents[0]?.description === null)) || item.subscriptions === NOT_SCHEDULED)));
    setData(lists);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

export const getList = async (listId, data, setData, setUpdatedData) => {
  const postBody = {
    query: searchListQuery,
    variables: {
      listId: Number(listId),
    },
  };

  const list = {};

  try {
    const response = await axios.post(`${wbConfig.baseUrl}/vnext/searchApi/graphql`, postBody);
    if (response.data?.errors) {
      console.error(response.data.errors);
      return;
    }

    const list = response?.data?.data?.list;
    list.id = list?.id;
    list.name = list?.name;
    list.listOwner = list?.owner?.id;
    list.owner =
      list?.owner?.id === window.uData.user_id
        ? 'You'
        : `${list?.owner?.firstname} ${list?.owner?.lastname}`;
    list.date = Number(list?.updatedAt);
    list.modified = new Date(list.date).toLocaleDateString(undefined, {
      day: '2-digit',
      year: 'numeric',
      month: 'short',
    });
    list.subscriptions = handleSubscription(list?.subscriptions);
    list.actions = { id: list.id, name: list.name };
    list.typeId = list?.type?.id;
    list.typeName = list?.type?.name;

    let exists = false;
    for (let i = 0; i < data.length; i++) {
      if (data[i].id === list.id) {
        data[i] = list;
        exists = true;
        break;
      }
    }
    if (!exists) {
      data.unshift(list);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setData(data);
    setUpdatedData(null);
  }
};
